import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  chartBox: {
    boxSizing: "border-box",
    width: "100%",
    height: "100%",
  },
  lineChart: {
    width: "100% !important",
  },
  barChart: {
    width: "100% !important",
  }
}));